export default "__VITE_ASSET__c65b71fa__"